import { useWorkspaceText } from './interface-copy';
import { useState } from 'react';
import { WorkspaceMarkdown } from './markdown';

// Large originals belong in storage/retrieval, not thousands of DOM nodes.
// This preview boundary never truncates ingestion or model source retrieval.
export function SourceText({ text, markdown = true }: { text: string; markdown?: boolean }) {
  const { text: uiText, rich: uiRich } = useWorkspaceText();
  const [limit, setLimit] = useState(24000);
  const preview = text.slice(0, limit);
  return (
    <>
      {markdown ? <WorkspaceMarkdown text={preview} /> : <pre>{preview}</pre>}
      {text.length > limit && (
        <button className="ws-text-button" onClick={() => setLimit((value) => value + 24000)}>
          {uiText('Show more of the original')}
        </button>
      )}
    </>
  );
}
